import { get, handleApiError, post } from '@helpers/httpClient';

import {
  mapHikingBaeWithTypeToFront,
  mapHikingDataToFront,
  mapHikingMemberAllergy,
  mapHikingTypeToFront,
} from '../@mappers/hiking.mapper';
import { mapBackendHikingListItem } from '../@mappers/hikingList.mapper';
import {
  ICreateHikingDTO,
  IHikingBaeWithTypeDTO,
  IHikingFieldsDTO,
  IHikingMemberAllergyDTO,
  IHikingTypeDTO,
  IUpdateHikingDTO,
} from '../@types/DTO/hiking.dto.types';
import { IHikingListItemDTO } from '../@types/DTO/hikingList.dto.types';
import { IHikingDataDTO } from '../@types/hiking.backTypes';
import { IHikingData } from '../@types/hiking.types';
import { IHikingListItem } from '../@types/hikingList.types';

export const getHikingDataAsync = async (id_hiking: number): Promise<IHikingData> => {
  const res = await get<IHikingDataDTO, { id: number }>('/ajax/hiking/one.php', { id: id_hiking });
  return mapHikingDataToFront(res);
};

export const getHikingFieldsAsync = async (
  id_hiking: number,
  csvFields: string,
): Promise<IHikingFieldsDTO> => {
  const res = await get<IHikingFieldsDTO>('/ajax/hiking/get_param.php', {
    id: id_hiking,
    name: csvFields,
  }).then<IHikingFieldsDTO>(handleApiError);
  return res;
};
type avai =
  | 'id_type'
  | 'id_route'
  | 'slogan'
  | 'name'
  | 'desc'
  | 'text'
  | 'start'
  | 'finish'
  | 'color'
  | 'bg'
  | 'id_region'
  | 'ava'
  | 'is_vacant_route'
  | 'allow_join_before'
  | 'members_limit';
export const setHikingFieldAsync = async (id_hiking: number, field: avai, value: any) => {
  const res = await post('/ajax/hiking/set_param.php', {
    id: id_hiking,
    name: field,
    value: value,
  }).then(handleApiError);
  return res;
};

export const getHikingTextAsync = async (id_hiking: number): Promise<string> => {
  const formData = new FormData();
  formData.append('id', id_hiking.toString());
  const res = await fetch('/ajax/hiking/text.php', {
    body: formData,
    method: 'post',
  });
  return res.text();
};

export interface IHikingListWithPaginationCriteria {
  limit?: number;
  offset?: number;
  startDate?: string;
  endDate?: string;
  type?: number;
  region?: number;
  id_route?: number;
  mode?: 'actual' | 'old';
  whose?: 'my' | 'all';
  actual?: 0 | 1;
  admin?: 0 | 1;
}

export const getHikingListWithPagination = async (
  criteria?: IHikingListWithPaginationCriteria,
): Promise<{ data: IHikingListItem[]; totalCount: number }> => {
  const raw = await get('/ajax/hiking/newList.php', criteria).then<{
    data: IHikingListItemDTO[];
    totalCount: number;
  }>(handleApiError);
  return { data: raw.data.map(mapBackendHikingListItem), totalCount: raw.totalCount };
};

export const getHikingTypesAsync = async () => {
  const res = await get('/ajax/hiking/types_list.php').then<IHikingTypeDTO[]>(handleApiError);
  return res.map(mapHikingTypeToFront);
};

export const createHikingAsync = (data: ICreateHikingDTO) => {
  return post('/ajax/hiking/save.php', data).then<{ success?: string; id: number }>(handleApiError);
};

export const updateHikingAsync = (data: IUpdateHikingDTO) => {
  return post('/ajax/hiking/save.php', data).then<{ success?: string; id: number }>(handleApiError);
};

export const getActualHikingList = async () => {
  const res = await get('/ajax/hiking/actual.php').then<IHikingBaeWithTypeDTO[]>(handleApiError);
  return res.map(mapHikingBaeWithTypeToFront);
};

interface IHikingMemberDatesShift {
  id_user: number;
  id_hiking: number;
  d1: string;
  d2: string;
}

export const hikingMemberDatesShift = (data: IHikingMemberDatesShift) => {
  return post('/ajax/hiking/user_date_shift.php', data).then(handleApiError);
};

export const hikingMemberJoin = (id_hiking: number) => {
  return post('/ajax/hiking/join.php', { id_hiking }).then<
    { success: boolean } | Array<{ id: string; name: string }>
  >(handleApiError);
};

export interface IHikingUncompletedInterview {
  id: string;
  name: string;
  cou: string;
}
export const getHikingUncompletedInterview = (id_hiking: number) => {
  return get('/ajax/hiking/iv_check.php', { id: id_hiking }).then<IHikingUncompletedInterview[]>(
    handleApiError,
  );
};

export const getHikingMembersAllergies = async (id_hiking: number) => {
  const res = await get('/ajax/hiking/allergies.php', { id_hiking }).then<
    IHikingMemberAllergyDTO[]
  >(handleApiError);
  return res.map(mapHikingMemberAllergy);
};
